module.exports = __webpack_public_path__ + "img/img26.7222b73e.jpg";